﻿import { retrieveRawInitData } from '@telegram-apps/sdk';

let _cachedIsTelegramMiniApp: boolean | null = null;

export function isTelegramMiniApp() {
	if (_cachedIsTelegramMiniApp!==null) {
		return _cachedIsTelegramMiniApp;
	}
	try {
		let data = retrieveRawInitData();
		_cachedIsTelegramMiniApp = _cachedIsTelegramMiniApp ?? !!data;
		return _cachedIsTelegramMiniApp;
	} catch (e) {
		_cachedIsTelegramMiniApp = false;
		return false;
	}
}
